<div class="flex items-center justify-center min-h-screen bg-white">
    <div class="flex flex-col items-center">
        <form [formGroup]="signupForm" (ngSubmit)="submit()">
            <!-- Auth Box -->
            <div
                class="w-full max-w-[600px] sm:min-w-[544px] rounded-[20px] border border-[#E2E8F0] bg-white/90 p-8 shadow-xl backdrop-blur">
                <div class="relative w-full flex justify-center">
                    <!-- Logo -->
                    <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />
                </div>
                <!-- Left arrow -->
                <div class="flex items-center gap-2 cursor-pointer" [routerLink]="['/landing']">
                    <img src="/assets/images/shared/left-arrow-black-icon.svg" alt="Back" class="h-5 w-auto" />
                    <p class="font-semibold text-sm">Back</p>
                </div>

                <!-- Welcome Text -->
                <div class="my-6">
                    <p class="text-[#0A0A0A] text-xl font-semibold">A few quick details</p>
                    <p class="text-[#717182] text-sm mt-2">
                        We’ll use this to personalise your experience in the community.
                    </p>
                </div>
                <!-- Full Name Input -->
                <div class="flex flex-col mb-4 space-y-2">
                    <label for="fullName" class="text-xs text-[#0A0A0A] font-semibold uppercase">Full Name</label>
                    <input
                        type="text"
                        id="fullName"
                        formControlName="fullName"
                        placeholder="How should we address you?"
                        class="w-full form-field-container" />
                    <!-- Error message -->
                    @if (signupForm.get('fullName')?.invalid && signupForm.get('fullName')?.touched) {
                        <div class="text-red-500 text-[0.625rem]">Please enter a full name.</div>
                    }
                </div>
                <!-- Password Input -->
                <div class="flex flex-col mb-4 space-y-2">
                    <label for="password" class="text-xs text-[#0A0A0A] font-semibold uppercase">Create Password</label>
                    <div class="relative">
                        <input
                            id="password"
                            formControlName="password"
                            placeholder="Create a secure password"
                            class="w-full form-field-container pr-10"
                            [type]="showPassword ? 'text' : 'password'" />
                        <img
                            alt="Toggle password visibility"
                            class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 cursor-pointer"
                            [src]="
                                showPassword ? '/assets/images/auth/eye-hide.svg' : '/assets/images/auth/eye-show.svg'
                            "
                            (click)="togglePasswordVisibility()" />
                    </div>
                    <!-- Error message -->
                    @if (signupForm.get('password')?.invalid && signupForm.get('password')?.touched) {
                        <div class="text-[#717182] text-[0.625rem]">Must be at least 8 characters</div>
                    }
                </div>

                <div class="flex flex-col gap-y-2 mb-4">
                    <div class="flex items-center gap-2 text-xs">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="h-3.5 w-3.5"
                            aria-hidden="true"
                            [ngClass]="hasMinLength() ? 'text-[#00A63E]' : 'text-slate-300'">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        <p
                            [class]="
                                hasMinLength() ? 'text-[#00A63E]' : 'text-[#717182]'
                            ">
                            At least 8 characters
                        </p>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="h-3.5 w-3.5"
                            aria-hidden="true"
                            [ngClass]="hasNumber() ? 'text-[#00A63E]' : 'text-slate-300'">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        <p [class]="hasNumber() ? 'text-[#00A63E]' : 'text-[#717182]'">
                            Contains a number
                        </p>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="h-3.5 w-3.5"
                            aria-hidden="true"
                            [ngClass]="hasLetter() ? 'text-[#00A63E]' : 'text-slate-300'">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        <p [class]="hasLetter() ? 'text-[#00A63E]' : 'text-[#717182]'">
                            Contains 1 lower and 1 upper case character
                        </p>
                    </div>
                </div>
                <!-- Signup Button -->
                <button type="submit" class="w-full border-button" [disabled]="signupForm.invalid">
                    Send verification email
                </button>
            </div>
                    <p class="mt-4 text-center text-[#717182] text-xs">Need help? Email us at <a
            href="mailto:admin@interseed.io"
            class="text-[#4F66FF] hover:text-[#1232FF] font-semibold"
        >admin@interseed.io</a></p>
        </form>
    </div>
</div>
